"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankAccounts = exports.BankAccount = void 0;
class BankAccount {
    constructor(bankAccount) {
        this.bankAccountId = 0;
        this.userID = 0;
        this.bankId = 0;
        this.branchNumber = '';
        this.accountNumber = '';
        this.accountDigit = '';
        if (!bankAccount)
            return;
        this.bankAccountId = bankAccount.bankAccountId;
        this.userID = bankAccount.userID;
        this.bankId = bankAccount.bankId;
        this.branchNumber = bankAccount.branchNumber;
        this.branchDigit = bankAccount.branchDigit;
        this.accountNumber = bankAccount.accountNumber;
        this.accountDigit = bankAccount.accountDigit;
    }
}
exports.BankAccount = BankAccount;
class BankAccounts {
    constructor(bankAccounts) {
        this.list = [];
        this.isLoaded = false;
        if (!bankAccounts)
            return;
        this.list = bankAccounts.list;
    }
}
exports.BankAccounts = BankAccounts;
//# sourceMappingURL=bankAccount.js.map